import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    width: '100%',
    maxWidth: '35rem',
  },
  formContainer: {
    backgroundColor: 'rgba(223, 219, 214, 0.60)',
    backdropFilter: 'blur(37.5px)',
    width: '100%',
    zIndex: 1,
  },
  titleBox: {
    padding: '0.625rem',
    backgroundColor: theme.palette.bg.sidebar,
    display: 'inline-block',
    marginBottom: '1.875rem',
  },
  titleText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
  },
  formInputBox: {
    padding: '1.875rem',
  },
  authInputStyles: {
    backgroundColor: 'rgba(0, 0, 0, 0.10)',
    border: 'none',
    color: `${theme.palette.text.primary} !important`,
    padding: '0.75rem 1.25rem',
    '& input': {
      color: `${theme.palette.text.primary} !important`,
      fontWeight: 600,
      '&::placeholder': {
        color: `${theme.palette.text.primary} !important`,
        fontWeight: 600,
      },
      '&.Mui-disabled': {
        background: 'none !important',
      },
    },
    '& .MuiInputAdornment-root, .MuiIconButton-root': {
      color: `${theme.palette.text.primary} !important`,
    },
    '&.Mui-disabled': {
      background: 'rgba(0, 0, 0, 0.10) !important',
    },
    '&.Mui-focused': {
      boxShadow: `0 0 0 1px ${theme.palette.text.primary}, 0 0 0 3px rgba(0, 0, 0, 0.25) !important`,
      borderColor: `${theme.palette.text.primary} !important`,
      outline: 'none !important',
    },
  },
  authBtn: {
    borderRadius: '0 !important',
    fontFamily: theme.typography.fontFamily,
    padding: '0.75rem 1.5rem',
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  primaryBtn: {
    background: '#000000',
    color: theme.palette.background.default,
    transition: 'all 0.2s ease',
    '&:hover': {
      background: '#333',
      borderColor: '#333',
    },
    '&:active': {
      background: '#222',
      borderColor: '#222',
    },
    '&:focus-visible, &:focus': {
      outline: '2px solid #222 !important',
      outlineOffset: '2px !important',
    },
    '&.Mui-disabled': {
      background: '#555 !important',
      borderColor: '#555 !important',
      color: '#E0E0E0 !important',
      cursor: 'not-allowed',
    },
  },
  secondaryBtn: {
    background: '#81B5D5',
    color: theme.palette.background.default,
    transition: 'all 0.2s ease',
    '&:hover': {
      background: '#6CA5C8',
      borderColor: '#6CA5C8',
    },
    '&:active': {
      background: '#5E9ABD',
      borderColor: '#5E9ABD',
    },
    '&:focus-visible , &:focus': {
      outline: '2px solid #5E9ABD !important',
      outlineOffset: '2px !important',
    },
    '&.Mui-disabled': {
      background: 'rgba(129, 181, 213, 0.4)',
      borderColor: 'rgba(129, 181, 213, 0.4)',
      color: 'rgba(0,0,0,0.4)',
    },
  },
}));

export default useStyles;
